import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { DwBreadCrumbCustomizationFunc, DwBreadCrumbCustomizationProcessor, DwBreadcrumbMenu, DwLookupInfo, DwMenu, DwMenuData, DwMetaDataService, DwMetaDataServiceToken, DwSecurityStateService, DwStorageUtil } from '@devwareapps/devware-cap';
import { AppMetaDataLookups } from '../../../meta-data/app-meta-data.service';
import { Observable, combineLatest } from 'rxjs';


@Injectable()
export class DocumentsBreadcrumbProcessor implements DwBreadCrumbCustomizationProcessor {
    coursesLookupItems: DwLookupInfo[] = [];
    moduleLookupItems: DwLookupInfo[] = [];
    lessonLookupItems: DwLookupInfo[] = [];

    constructor(private dwSecurityState: DwSecurityStateService,
        @Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService,
        private dwStorageUtil: DwStorageUtil
    ) {

    }

    processBreadcrumb(breadcrumbMenu: DwBreadcrumbMenu, routeSnapshot: ActivatedRouteSnapshot, url: string, menu: DwMenu, menuData: DwMenuData) {
        if (routeSnapshot.params?.folderId) {
            breadcrumbMenu.breadcrumbDisplay = routeSnapshot.params?.folderId.replace(/_/g, ' ');
        }

        if ((url.includes('/documents/') || url.includes('/pro-tools/')) && ((url.includes('/view') || url.includes('/edit/')))) {
            const parts = url.split('/');
            const documentId = parts[parts.length - 1];
            const view = parts[parts.length - 2];

            if (documentId == 'view') {
                breadcrumbMenu.breadcrumbDisplay = 'View';
            } else if (view == 'edit') {    
                breadcrumbMenu.breadcrumbDisplay = 'Edit';
            } else {
                breadcrumbMenu.hideBreadcrumb = true; 
            }
        }
    }
}

DwBreadCrumbCustomizationFunc({
    keyName: 'DocumentsBreadcrumbProcessor',
    display: 'Documents Breadcrumb Processor',
    order: 1
}, DocumentsBreadcrumbProcessor)